import { render, staticRenderFns } from "./ImportedTweet.vue?vue&type=template&id=0d6f3c4a&scoped=true&"
import script from "./ImportedTweet.vue?vue&type=script&lang=js&"
export * from "./ImportedTweet.vue?vue&type=script&lang=js&"
import style0 from "./ImportedTweet.vue?vue&type=style&index=0&id=0d6f3c4a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d6f3c4a",
  null
  
)

export default component.exports